import React, {Component} from 'react';
import {
    Router,
    Route,
    Switch, BrowserRouter,
} from 'react-router-dom'

import styled from 'styled-components'

import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../to-js";
import Footer from "./layout/Footer";
import Cart from "./pages/Cart";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import AddToCartModal from "./layout/AddToCartModal";
import * as Actions from "../actions/actions";
import history from '../history'
import {withRouter} from "react-router-dom";

const page404 = () => <div><h1>404</h1></div>;

const Button = styled.button`
  position: fixed;
  z-index: 10000;
  bottom: 10px;
  right: 10px;      
`;

//const FooterWR = withRouter(Footer);
const ModalWR = withRouter(AddToCartModal);

class App extends Component {
    render(history) {
        return (
            <BrowserRouter>
                <div className={this.props.className}>
                    <Switch>
                        <Route path={'/catalog'} component={Catalog}/>
                        <Route path='/cart' component={Cart}/>
                        <Route path={'/'} component={Home}/>
                        <Route component={page404}/>
                    </Switch>
                    <Footer/>
                    <ModalWR/>
                </div>
            </BrowserRouter>
        );
    }
}

function mapStateToProps(state) {
    return {
        redirect: state.getIn(['state', 'redirect'])
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        redirectAction: Actions.redirect,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(styled(App)`
  height: 100%;
  display: flex;
  flex-direction: column;
  
  
  //typography
  font-size: ${p => p.theme.sFontRegular};
  font-family: 'Raleway', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  color: ${p => p.theme.cText};
  line-height: 1.4;
  
  p{
    margin-bottom: 1em;
    &:last-child{
      margin-bottom: 0;
    }
  }
  
  
`));
